import { yupResolver } from "@hookform/resolvers/yup"
import { Button, Center, Group, Select, Text, TextInput } from "@mantine/core"
import { useForm } from "react-hook-form"
import { Link, useNavigate } from "react-router-dom"
import * as yup from "yup"
import { useForgetPasswordMutation } from "../store/account.query"
import { useState } from "react"
import { t } from "i18next"
import { parsePhoneNumber } from "../../../shared/utility/Tools/tools"
import { flexiblePhoneRegEx } from "../../../shared/utility/Tools/RegEx"

const schema = yup
  .object()
  .shape({
    phoneNumber: yup
      .string()
      .matches(
        flexiblePhoneRegEx,
        "Phone number is not valid",
      )
      .required("Phone Number  is required"),
  })
  .required()

export default function ForgotPasswordPage() {
  const navigate = useNavigate()

  const defaultValue = {
    phoneNumber: "",
  }
  const [forgetPassword, forgetPasswordResponse] = useForgetPasswordMutation()
  const [userType, setUserType] = useState<
    "employee" | "corporate" | "admin" | "owner"
  >("employee")
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValue,
    mode: "all",
  })

  const onSubmit = (data: any) => {
    const forgetData = { type: userType, phoneNumber: parsePhoneNumber(data.phoneNumber) }
    forgetPassword(forgetData)
  }
  const onError = (error: any) => {
    console.log(
      "🚀 ~ file: forgot-password-page.tsx:43 ~ onError ~ error:",
      error,
    )
  }

  return (
    <>
      <div className="flex justify-center items-center w-full min-h-screen">
        <section className="flex flex-col justify-center items-center pt-6">
          <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                BE Property Management
              </h1>
              <form
                className="space-y-4 md:space-y-6"
                onSubmit={handleSubmit(onSubmit, onError)}
              >
                <div
                  className="flex items-center p-4 mb-4 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400"
                  role="alert"
                >
                  <svg
                    className="flex-shrink-0 inline w-4 h-4 me-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
                  </svg>
                  <span className="sr-only">Info</span>
                  <div>{t("forgetPasswordDescription")}</div>
                </div>
                <div>
                  <TextInput
                    {...register(`phoneNumber`)}
                    label={t("phoneNumber")}
                    placeholder={t("phoneNumber")}
                    classNames={{
                      input:
                        " bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                    }}
                    className="w-full"
                    error={errors.phoneNumber?.message}
                  />
                </div>

                <div>
                  <Select
                    classNames={{
                      label: "dark:text-white",
                      input:
                        " bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                    }}
                    className="w-full"
                    label={t("type")}
                    placeholder={t("type")}
                    value={userType}
                    onChange={(e: any) => setUserType(e)}
                    data={[
                      { label: t("admin"), value: "employee" },
                      { label: t("owner_one", { count: 1 }), value: "owner" },
                      { label: t("tenant_one", { count: 1 }), value: "tenant" },
                    ]}
                  />
                </div>
                <Button
                  type="submit"
                  loading={forgetPasswordResponse.isLoading}
                  className="w-full text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  {t("resetPassword")}
                </Button>

                <Text className="text-sm font-light text-gray-500 dark:text-gray-400">
                  <Link
                    className="font-medium text-blue-600 hover:underline dark:text-blue-500"
                    to="/login"
                  >
                    {t("login")}
                  </Link>
                </Text>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
